import { render, staticRenderFns } from "./SearchProduct.vue?vue&type=template&id=b3613da2&"
import script from "./SearchProduct.vue?vue&type=script&lang=js&"
export * from "./SearchProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports